import React from 'react'
import { Stack, Text } from '@mantine/core'
import ExpandableListWrapper from '../../../components/ExpandableListWrapper'
import EnforcementCase from './EnforcementCase'
import { useTheme } from '../../../components/ThemeProvider'

interface ImplementationCasesProps {
  data: any
}

export default function ImplementationCases({ data }: ImplementationCasesProps) {
  const theme = useTheme()
  const cases = data?.exec_case_info ?? []
  const caseCount = cases.length

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        执行案件
      </Text>
      <Stack gap="sm" className="mt-3">
        <ExpandableListWrapper isEmpty={caseCount === 0}>
          {cases.map((item: any, index: number) => (
            <EnforcementCase number={index + 1} key={index} item={item} />
          ))}
        </ExpandableListWrapper>
      </Stack>
    </div>
  )
}
